import React, { useState, useEffect } from "react";
import { Children } from 'react';
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter
} from "@coreui/react"
import { TransText } from "..";

export const BaseModal = ({ children, title, size, color, open, onClose }) => {
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    setIsOpen(open)
  }, [open]);
  return (
    <CModal
      show={isOpen}
      closeOnBackdrop={false}
      onClose={() => { setIsOpen(); onClose() }}
      size={size || 'lg'}
      color={color || 'primary'}
    >
      {title && <CModalHeader closeButton>
        <CModalTitle><TransText>{title}</TransText></CModalTitle>
      </CModalHeader>}
      <CModalBody className="v-tabs">
        {Children.map(children, child => {
          return child.props.type === 'content' ? child : <></>
        }
        )}
      </CModalBody>
      <CModalFooter className="d-flex justify-content-between">
        {/* <CButton
          color="secondary"
          onClick={() => { setIsOpen(); onClose() }}
        >Hủy</CButton> */}
        {Children.map(children, child => {
          return child.props.type === 'footer' ? child : <></>
        }
        )}
      </CModalFooter>
    </CModal>
  );
};
